<template>
  <v-card>
    <v-card-title
      :class="current.titleClass"
      v-html="current.title"
    >
    </v-card-title>
    <v-card-text>
      <v-container v-html="current.content"/>
    </v-card-text>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn
        @click="onCancel"
        text
      >
        {{current.cancelText}}
      </v-btn>
      <v-btn
        color="primary"
        text
        @click="onConfirm"
      >
        {{current.confirmText}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "ConfirmCard",
    props: {
      current: {
        type: Object,
        required: true
      }
    },
    methods: {
      onCancel() {
        this.$emit("cancel")
      },
      onConfirm() {
        this.$emit("confirm")
      }
    }
  }
</script>

<style scoped>

</style>
